module.exports = ".editorPreviewLoaderCon {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  left: 0%;\n  top: 0%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/bookShared/editor/editor.component.css
// module id = ./src/app/bookShared/editor/editor.component.css
// module chunks = main